import { ServiceAppService } from '../../../security/service-app.service';
import { FileUpload } from '../../../shared/fileupload/fileupload';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService, PrimeNGConfig } from 'primeng/api';
import { Table } from 'primeng/table';
import { ExportExcelService } from '../../../shared/excel-service/export-excel.service';
import * as XLSX from 'xlsx';
import { Estado } from '../../../shared/shared/estado.enum';
import { ICadastro, IFiltros } from './interface-regional-parametro';

@Component({
  selector: 'app-regional-parametro',
  templateUrl: './regional-parametro.component.html',
  styleUrls: ['./regional-parametro.component.scss']
})

export class RegionalParametroComponent implements OnInit {
  cols: any[];
  first = 0;
  rows = 10;
  dados: any[];
  _selectedColumns: any[];
  loading: boolean;
  nomeModulo: any;
  progress = false;
  totalRegistros: any = 0;
  displayRows: number = 0;
  filtrosNew: IFiltros;
  state: Estado;
  cadastro: ICadastro;
  cadastroTitulo: string = '';
  definirFiltros: string = '';
  exibeFiltros: boolean = false;
  exibeCadastro: boolean = false;
  tiposMarca: any[] = [];
  selectMarca: any = null;
  selectedDados: any[] = [];

  @ViewChild('dt') dt: Table;
  @ViewChild('fileUploader') fileUpload: FileUpload;
  constructor(private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private service: ServiceAppService,
    private exportExcelService: ExportExcelService,
    private config: PrimeNGConfig) {
    this.nomeModulo = 'regional-parametro';
  }


  // dadosTranslate = {
  //   "Regional": "parametros.regionalParametro.regional",
  //   "Contato": "parametros.regionalParametro.contato",
  //   "E-mail": "relatorioVeiculos.regionalParametro.email",
  //   "DDD": "relatorioVeiculos.regionalParametro.modelo",
  //   "Telefone": "relatorioVeiculos.regionalParametro.valorVenda",
  //   "Ações": "relatorioVeiculos.regionalParametro.corExterna"  
  // }

  ngOnInit(): void {
    const ano = new Date();
    this.filtrosNew = { paginaAtual: 1, quantidadeRegistrosPorPagina: 10,
      descricaoRegiao: '', nomeContato: ''
    }
    this.retornaDados();

    this.cols = [
      { field: 'descricao_regiao', header: 'Regional' },
      { field: 'nome_contato', header: 'Contato' },
      { field: 'email_contato', header: 'E-mail' },
      { field: 'ddd_contato', header: 'DDD' },
      { field: 'telefone_contato', header: 'Telefone' },
      { field: 'edit', header: 'Ações', width: '50px' }
    ];

    this.config.setTranslation({
      "startsWith": "Começa com",
      "contains": "Contém",
      "notContains": "Não Contém",
      "endsWith": "Termina com",
      "equals": "Igual",
      "notEquals": "Não é igual",
      "noFilter": "Sem Filtro",
      "lt": "Menor que",
      "lte": "Menos que ou igual a",
      "gt": "Maior que",
      "gte": "Mais que ou igual a",
      "dateIs": "Data é",
      "dateIsNot": "Data não é",
      "dateBefore": "Data é anterior a",
      "dateAfter": "Data é posterior a",
      "addRule": "Adicionar Regra",
      "removeRule": "Remover Regra",
      "apply": "Aplicar",
      "clear": "Limpar",
      "matchAll": "Combinar tudo",
      "matchAny": "Combinar com qualquer"
    });

    this._selectedColumns = this.cols;
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    //restore original order
    this._selectedColumns = this.cols.filter(col => val.includes(col));
  }

  onPageChange(event: any): void {
    this.filtrosNew.paginaAtual = event.page + 1;
    this.filtrosNew.quantidadeRegistrosPorPagina = event.rows;
    this.displayRows = event.first;
    this.first = event.first;
    this.retornaDados();
  }

  retornaDados() {
    this.loading = true;
    this.service.getDados(`/regional_venda?descricaoRegiao=${this.filtrosNew.descricaoRegiao}&nomeContato=${this.filtrosNew.nomeContato}&paginaAtual=${this.filtrosNew.paginaAtual}&quantidadeRegistrosPorPagina=${this.filtrosNew.quantidadeRegistrosPorPagina}`).subscribe(res => {
      this.totalRegistros = res.total_registros;
      this.dados = res.dados;

      this.loading = false;
    });
  }

  recarregaDados() {
    this.filtrosNew.paginaAtual = 1;
    this.filtrosNew.quantidadeRegistrosPorPagina = 10;
    this.first = 0;

    this.retornaDados();
  }

  createDateFromMonth(month: number, year: number = new Date().getFullYear()): Date {
    const date = new Date(year, month - 1, 1);
    return date;
  }

  editDados(dado: ICadastro, estado: Estado) {
    console.log(dado)
    this.cadastroTitulo = estado === Estado.edit ? 'Editar' : estado === Estado.view ? 'Visualizar' : '';
    this.state = estado;
    this.cadastro = { ...dado };
    this.exibeCadastro = true;
  }

  insertDados() {
    this.cadastroTitulo = 'Cadastrar';
    this.state = Estado.insert;
    this.cadastro = {descricao_regiao: null, nome_contato: null, ddd_contato: null, telefone_contato: null, email_contato: null};
    this.exibeCadastro = true;
  }

  removerRegistro(event: any) {
    console.log(event);
    this.confirmationService.confirm({
      key: 'regional-parametro',
      message: 'Tem certeza de que deseja apagar o dado?',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        this.service.exclusao(`/regional_venda/exclusao?id_regional=${event.id}`).subscribe(res => {
          this.selectedDados = [];
          this.recarregaDados();
          this.messageService.add({ key: 'regional-parametro', severity: 'success', detail: "Dado excluido com sucesso.", life: 3000 });
        }, (error) => {
          this.selectedDados = [];
          this.messageService.add({ key: 'regional-parametro', severity: 'warn', detail: error.error.aviso, life: 5000 });
        });
      },
    });
  }
  
  removerRegistros() {
    this.confirmationService.confirm({
      key: 'regional-parametro',
      message: 'Tem certeza de que deseja apagar os dados?',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        console.log(this.selectedDados);

        const ids = this.selectedDados.map(res => res.id);

        const idParam = ids.join(',');
  
        this.service.exclusao(`/regional_venda/exclusaoMultipla?id_regional=${idParam}`).subscribe(res => {
          this.selectedDados = [];
          this.recarregaDados();
          this.messageService.add({ key: 'regional-parametro', severity: 'success', detail: "Dado excluido com sucesso.", life: 3000 });
        }, (error) => {
          this.selectedDados = [];
          this.messageService.add({ key: 'regional-parametro', severity: 'warn', detail: error.error.message, life: 5000 });
        });
      },
    });
  }

  exportExcel() {
    let registros = [];
    this.service.getDados(`/regional_venda?descricaoRegiao=${this.filtrosNew.descricaoRegiao}&nomeContato=${this.filtrosNew.nomeContato}&paginaAtual=${this.filtrosNew.paginaAtual}&quantidadeRegistrosPorPagina=${this.filtrosNew.quantidadeRegistrosPorPagina}`).subscribe(res => {
      registros = res.dados;

      if (registros.length > 0) {
        this.exportExcelService.nomeModulo = this.nomeModulo;
        this.exportExcelService.ExportTOExcelJSON(registros.map(r => {
          let linha = {};
          this.cols.forEach(c => linha[(c.header)] = (r[c.field]));

          if (linha.hasOwnProperty('Ações')) {
            delete linha['Ações'];
          }

          return linha;
        }));
      }
    });
  }

  showFilters() {
    this.exibeFiltros = true;
  }

  retornaAplicarFiltros(filtros: IFiltros) {
    this.filtrosNew.paginaAtual = 1;
    this.filtrosNew.quantidadeRegistrosPorPagina = 10;
    this.filtrosNew = filtros;
    this.exibeFiltros = false;
    this.retornaDados();
  }

  retornaRecarregaDados(event: any) {
    this.recarregaDados();
  }

  retornaFecharModalCadastro(dialog: boolean) {
    this.exibeCadastro = dialog;
  }

  retornaFecharModalFiltros(dialog: boolean) {
    this.exibeFiltros = dialog;
  }
}